import uuid from 'react-uuid'

export const baseMessage = {
  id: uuid(),
  role: 'assistant',
  content: `Hi there! I'm here to assist you with all your Number documentation needs. Feel free to ask me any questions you have about our APIs, SDKs, or anything else related to technical integration. Let's get started!`,
  date: new Date().toISOString()
}
